// Free-item guard: a $0 "free" copy may only stay in the cart alongside the
// item that earns it. Without this, a shopper can add the bundle (which adds
// the free protector), delete the bundle, and check out with the free item
// on its own (order #417356). Runs on every page: on load, after any cart
// change, and right before Checkout proceeds; drops free lines down to the
// quantity their qualifying items allow and says why.
(function () {
  // Each rule: the free variants it pays for and what earns them. Earned by
  // variant ids (one free per qualifying unit), or by product ids with
  // perOrder (that many per order once any unit is in the cart). A free line
  // can draw on every rule that lists its variant.
  var RULES = [
    // Cooling Pillow Protector - FREE (Queen): DCOP Standard Comfort Bundle,
    // or the paid add-on protector (DCOP add-on card test).
    { free: [68283681210603], variants: [44444655911147, 68283197948139] },
    // Cooling Pillow Protector - FREE (King): DCOP Thick Comfort Bundle.
    { free: [68284244328683], variants: [44444656009451] },
    // BFCM subscriber bonus (snippets/ubx-subscriber-bonus.liquid), Queen or
    // King protector: one with the subscriber copies of DCOP, ThermaCool
    // Comforter, ThermaCool Sheets and Luxe Sheets...
    { free: [68283681210603, 68284244328683], products: [15465567158507, 15465567224043, 15465567355115, 15465567420651], perOrder: 1 },
    // ...two with the Mattress Protector copy...
    { free: [68283681210603, 68284244328683], products: [15465567453419], perOrder: 2 },
    // ...and DeepSleep Pro Eye Mask - FREE with the Travel Neck Pillow copy.
    { free: [68299999477995], products: [15465567518955], perOrder: 1 }
  ];
  var NOTE = 'The free protector comes with the offer that includes it, so it was removed from your cart.';
  var NOTES = {
    68299999477995: 'The free eye mask comes with the offer that includes it, so it was removed from your cart.'
  };

  var running = null;

  function overLimit(cart) {
    var items = cart.items || [];
    var qtyByVariant = {};
    var qtyByProduct = {};
    items.forEach(function (item) {
      qtyByVariant[item.variant_id] = (qtyByVariant[item.variant_id] || 0) + item.quantity;
      qtyByProduct[item.product_id] = (qtyByProduct[item.product_id] || 0) + item.quantity;
    });
    // How many free items each rule still allows.
    var left = RULES.map(function (rule) {
      var units = 0;
      (rule.variants || []).forEach(function (id) { units += qtyByVariant[id] || 0; });
      (rule.products || []).forEach(function (id) { units += qtyByProduct[id] || 0; });
      if (!units) return 0;
      return rule.perOrder || units;
    });
    var changes = [];
    items.forEach(function (item) {
      var covered = false;
      var keep = 0;
      RULES.forEach(function (rule, i) {
        if (rule.free.indexOf(item.variant_id) === -1) return;
        covered = true;
        var take = Math.min(left[i], item.quantity - keep);
        left[i] -= take;
        keep += take;
      });
      if (covered && keep < item.quantity) {
        changes.push({ key: item.key, quantity: keep, note: NOTES[item.variant_id] || NOTE });
      }
    });
    return changes;
  }

  // The live region is in the page, empty, before any message goes in: one
  // created together with its message isn't announced.
  var note = document.createElement('div');
  note.setAttribute('data-free-gift-note', '');
  note.setAttribute('role', 'status');
  note.style.cssText = 'position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:2147483000;' +
    'max-width:min(92vw,420px)';
  document.body.appendChild(note);
  var hideNote;

  function showNote(text) {
    var box = document.createElement('div');
    box.style.cssText = 'padding:12px 16px;border-radius:10px;background:#202f5a;color:#fff;' +
      'font:600 14px/1.35 Catamaran,sans-serif;box-shadow:0 6px 20px rgba(0,0,0,.25);text-align:center';
    box.textContent = text;
    note.replaceChildren(box);
    clearTimeout(hideNote);
    hideNote = setTimeout(function () { note.replaceChildren(); }, 6000);
  }

  // Resolves true when the cart was changed.
  function guard() {
    if (running) return running;
    running = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var changes = overLimit(cart);
        if (!changes.length) return false;
        console.warn('[free-gift-guard] Removing free items without their qualifying item:', changes);
        return changes.reduce(function (p, change) {
          return p.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: change.key, quantity: change.quantity })
            }).then(function (r) {
              if (!r.ok) throw new Error('cart/change ' + r.status);
            });
          });
        }, Promise.resolve()).then(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
          showNote(changes[0].note);
          return true;
        });
      })
      .catch(function (err) {
        console.error('[free-gift-guard] Check failed:', err);
        return false;
      })
      .then(function (changed) {
        running = null;
        return changed;
      });
    return running;
  }

  // After the theme changes the cart (remove, quantity) or adds to it.
  ['cart:updated', 'ajaxProduct:added'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(guard, 400); });
  });

  // Checkout: check first, then continue. If something was removed, stay so
  // the shopper sees the updated cart and the note. Continuing re-clicks the
  // button so the apps listening for that click (CandyRack on the button,
  // Intelligems and Clarity on the document) still see it.
  var passing = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"]');
    if (!btn || passing) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    guard().then(function (changed) {
      if (changed) return;
      passing = true;
      btn.click();
      setTimeout(function () { passing = false; }, 3000);
    });
  }, true);

  if (document.readyState !== 'loading') {
    guard();
  } else {
    document.addEventListener('DOMContentLoaded', guard);
  }
})();
